import { useEffect, useState } from 'react';
import type { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { SwiperClass } from 'swiper/react';
import { Asset } from '../../asset';
import { usePhotoGridStore, usePhotoGridStoreMutation } from '../../usePhotoStore';
import styles from './ThumbnailSection.module.scss';

export const ThumbnailSection: FC = () => {
    // TODO: Remove the eslint-disable-next-line when migrating to TypeScript 5 and Swiper typings
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-redundant-type-constituents
    const [swiperRef, setSwiperRef] = useState<SwiperClass | null>(null);
    const { data } = usePhotoGridStore();
    const mutation = usePhotoGridStoreMutation();

    useEffect(() => {
        // TODO: Remove the eslint-disable-next-line when migrating to TypeScript 5 and Swiper typings
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (data && swiperRef && swiperRef.slides) {
            const { selectedAsset, assets } = data;
            const currentSlideIndex = assets?.findIndex((a) => selectedAsset?.id === a.id);
            // TODO: Remove the eslint-disable-next-line when migrating to TypeScript 5 and Swiper typings
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment
            const currentSlide = swiperRef.slides.find(
                (slide: HTMLElement) =>
                    slide.dataset.swiperSlideIndex === String(currentSlideIndex),
            );
            // TODO: Remove the eslint-disable-next-line when migrating to TypeScript 5 and Swiper typings
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            if (currentSlide && !currentSlide.classList.contains('swiper-slide-visible')) {
                // TODO: Remove the eslint-disable-next-line when migrating to TypeScript 5 and Swiper typings
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                swiperRef?.slideToLoop(currentSlideIndex, 300, true);
            }
        }
    }, [swiperRef, data]);

    if (!data) {
        return null;
    }

    const { assets = [], selectedAsset } = data;

    return (
        <section
            data-testid="photo-grid-zoom-thumbnails-section"
            className={`mx-4 flex ${styles.zoomOverlayThumbnailContainer}`}
        >
            <div className="flex w-full justify-center">
                <Swiper
                    spaceBetween={16}
                    slidesPerView="auto"
                    loop
                    onSwiper={setSwiperRef}
                    watchSlidesProgress
                >
                    {assets.map((asset) => (
                        <SwiperSlide key={asset.id}>
                            <button
                                className={`h-16 w-16 overflow-hidden rounded ${
                                    asset.id === selectedAsset?.id
                                        ? 'border-[1.5px] border-slt-pepper-1000'
                                        : 'border border-slt-pepper-700'
                                }`}
                                type="button"
                                onClick={() =>
                                    mutation.mutate({
                                        selectedAsset: asset,
                                        isZoomModalOpen: true,
                                    })
                                }
                            >
                                <Asset asset={asset} isThumbnail />
                            </button>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};
